import { useRecordContext } from 'react-admin'
import { roleChoices } from '../../helpers'

export const RoleNameField = (props) => {
   const {role} = useRecordContext(props)
   return role !== null && role !== undefined ? <span>{roleChoices[role]}</span> : null
}